var RelatedLinksEditor_1;
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let RelatedLinksEditor = RelatedLinksEditor_1 = class RelatedLinksEditor extends Vue {
    static NormalizeLink(link) {
        const value = (link || "").trim();
        if (value === "")
            return "";
        return value.startsWith("/") ? value : "/" + value;
    }
    static IsIncomplete(link) {
        const title = (link.title || "").trim();
        const url = (link.link || "").trim();
        return (title === "") !== (url === "");
    }
    static IsValid(links) {
        if (!Array.isArray(links))
            return true;
        return !links.some(link => RelatedLinksEditor_1.IsIncomplete(link));
    }
    static Sanitize(links) {
        if (!Array.isArray(links))
            return [];
        return links
            .map(link => ({
            title: (link.title || "").trim(),
            link: RelatedLinksEditor_1.NormalizeLink(link.link),
        }))
            .filter(link => link.title !== "" || link.link !== "");
    }
    get HasIncompleteRow() {
        return !RelatedLinksEditor_1.IsValid(this.value);
    }
    IsTitleInvalid(link) {
        return (link.title || "").trim() === "" && (link.link || "").trim() !== "";
    }
    IsLinkInvalid(link) {
        return (link.link || "").trim() === "" && (link.title || "").trim() !== "";
    }
    Clone() {
        return this.value.map(link => ({ ...link }));
    }
    Emit(links) {
        this.$emit("input", links);
    }
    UpdateTitle(index, title) {
        const links = this.Clone();
        links[index].title = title;
        this.Emit(links);
    }
    UpdateLink(index, link) {
        const links = this.Clone();
        links[index].link = link;
        this.Emit(links);
    }
    NormalizeAt(index) {
        const links = this.Clone();
        const normalized = RelatedLinksEditor_1.NormalizeLink(links[index].link);
        if (normalized === links[index].link)
            return;
        links[index].link = normalized;
        this.Emit(links);
    }
    Add() {
        this.Emit([...this.Clone(), { title: "", link: "" }]);
    }
    Remove(index) {
        const links = this.Clone();
        links.splice(index, 1);
        this.Emit(links);
    }
    Move(index, offset) {
        const target = index + offset;
        if (target < 0 || target >= this.value.length)
            return;
        const links = this.Clone();
        const moved = links[index];
        links[index] = links[target];
        links[target] = moved;
        this.Emit(links);
    }
};
__decorate([
    Prop({ default: () => [] })
], RelatedLinksEditor.prototype, "value", void 0);
RelatedLinksEditor = RelatedLinksEditor_1 = __decorate([
    Component
], RelatedLinksEditor);
export default RelatedLinksEditor;
